var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-found"},[_c('IconNoData'),_c('h1',[_vm._v("No results found")]),_c('p',[_vm._v("Try adjusting your search or filter to find what you’re looking for.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }